<template>
  <AdminModal :title="title" @close="$emit('close')">
    <p class="ad-note">{{ intro }}</p>
    <div class="ad-linkbox">
      <input ref="input" class="ad-input" :value="url" readonly @focus="$event.target.select()" />
      <button type="button" class="ad-btn ad-btn--primary" @click="copy">{{ copied ? 'Copiado' : 'Copiar' }}</button>
    </div>
    <p class="ad-hint" style="margin-top: 8px">Vence {{ expiresText }}. También se envió por correo; este link es por si no le llega.</p>
    <template #footer>
      <button type="button" class="ad-btn ad-btn--ghost" @click="$emit('close')">Cerrar</button>
    </template>
  </AdminModal>
</template>

<script setup>
import { ref, computed } from 'vue'
import AdminModal from './AdminModal.vue'
import { formatDateTime } from './adminFormat'

const props = defineProps({
  title: { type: String, default: 'Link de activación' },
  intro: { type: String, default: 'Comparte este link con la persona para que cree su contraseña.' },
  url: { type: String, required: true },
  expiresAt: { type: [String, Date], default: null },
})
defineEmits(['close'])

const input = ref(null)
const copied = ref(false)
const expiresText = computed(() => formatDateTime(props.expiresAt))

async function copy() {
  try {
    await navigator.clipboard.writeText(props.url)
  } catch {
    input.value?.select()
    document.execCommand('copy')
  }
  copied.value = true
  setTimeout(() => { copied.value = false }, 1800)
}
</script>